/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropwinsperday3Inputs */

const en_dropwinsperday3 = /** @type {(inputs: Dropwinsperday3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wins per day`)
};

const de_dropwinsperday3 = /** @type {(inputs: Dropwinsperday3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewinne pro Tag`)
};

/**
* | output |
* | --- |
* | "Wins per day" |
*
* @param {Dropwinsperday3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinsperday3 = /** @type {((inputs?: Dropwinsperday3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinsperday3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinsperday3(inputs)
	return de_dropwinsperday3(inputs)
});
export { dropwinsperday3 as "dropWinsPerDay" }